export default __webpack_public_path__ + "static/media/link.f854678e.svg";